<template>
  <div class="referred-job">
    <router-link
      :to="jobDetailsPageRoute"
      :class="{'heading-3-underline': !$mq.phone, 'paragraph': $mq.phone}"
      class="referred-job-title paragraph-secondary">
      {{ referredJob.title }}
    </router-link>

    <div class="referred-job-info is-flex-tablet">
      <div class="is-flex">
        <referred-job-info-item v-if="referredJob.annual_salary" :text="annualSalary">
          <svg-icon name="wallet"></svg-icon>
        </referred-job-info-item>

        <referred-job-info-item v-if="referredJob.location" :text="referredJob.location">
          <svg-icon name="location"></svg-icon>
        </referred-job-info-item>

        <referred-job-info-item v-if="referredJob.industry" :text="referredJob.industry">
          <svg-icon name="industry"></svg-icon>
        </referred-job-info-item>

      </div>
      <span v-translate class="paragraph-gray">You referred this job.</span>
    </div>
  </div>
</template>

<script>

import 'top20common/distribution/icons/wallet';
import 'top20common/distribution/icons/location';
import 'top20common/distribution/icons/industry';

import currencies from 'top20common/distribution/services/currencies';
import formatter from 'top20common/distribution/services/formatter';

import ReferredJobInfoItem from './ReferredJobInfoItem';

export default {
  props: {
    referredJob: {type: Object}
  },
  computed: {
    annualSalary() {
      return currencies.getShortFormatNumberWithCurrency(this.referredJob.annual_salary);
    },
    jobDetailsPageRoute() {
      return {
        name: 'job',
        params: {
          lang: this.$route.params.lang,
          code: this.referredJob.code,
          title: formatter.slugify(this.referredJob.title)
        }
      };
    }
  },
  components: {
    ReferredJobInfoItem
  }
};
</script>

<style lang="scss">
@import '~VariablesStyles';

.referred-job {
  text-transform: none;

  .referred-job-title {
    text-decoration: underline;
  }

  .referred-job-info {
    & > div {
      flex: 1;
    }
  }
}

@media (min-width: $tablet) {
  .referred-job-info {
    padding: 10px 0 0;
  }
}

@media (max-width: $tablet) {
  .referred-job-info {
    & > div:first-child {
      padding: 8px 0 5px 0;
    }
    & > div:last-child {
      padding: 0;
    }
  }
}
</style>
